import React, { useState, useEffect } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Project from "../../components/Project";
import SectionTitle from "../../components/SectionTitle";
import { ProjectContainer, ProjectsStyled } from "./styles";
import { getProjects } from "../../client";

function Projects() {
  // const [activeSection, setActiveSection] = useState(1);
  const [projectList, setProjectList] = useState();

  const callGetProjects = async () => {
    const res = await getProjects();
    setProjectList(res);
  };

  useEffect(() => {
    callGetProjects();
  }, []);

  return (
    <ProjectsStyled>
      <SectionTitle text={"Projects"} />
      {/* <SectionButtonContainer>
        <Button
          text={"WEB 2"}
          fontSize={"25px"}
          active={activeSection === 1}
          onClick={() => setActiveSection(1)}
        />
        <Button
          text={"WEB 3"}
          fontSize={"25px"}
          active={activeSection === 2}
          onClick={() => setActiveSection(2)}
        />
      </SectionButtonContainer> */}
      <ProjectContainer>
        {projectList?.length > 0 &&
          projectList?.map((project, index) => (
            <Project project={project} key={index + 1} />
          ))}
      </ProjectContainer>
    </ProjectsStyled>
  );
}

export default Projects;
